const DotsLoader = () => {
  return (
    <div className='flex items-center justify-center h-full space-x-2'>
      <span className='sr-only'>Loading...</span>
      <div className='h-8 w-8 dark:bg-primary bg-accent rounded-full animate-bounce [animation-delay:-0.3s]'></div>
      <div className='h-8 w-8 dark:bg-primary bg-accent rounded-full animate-bounce [animation-delay:-0.15s]'></div>
      <div className='w-8 h-8 rounded-full dark:bg-primary bg-accent animate-bounce'></div>
    </div>
  )
}

export default DotsLoader
